<template>
  <v-form ref="form" v-model="valid">
    <v-layout column v-if="mostrarComenzarConfiguracion || borradoDeFuera" px-4>
      <span class="grey--text v-label">
        {{$t('configuracion.sinConfiguracion')}}
      </span>
      <v-layout justify-center pt-4>
        <v-btn 
          @click="comenzarConfiguracion()" 
          large color="primary"
        >
          {{$t('general.misc.comenzar')}}
        </v-btn>
      </v-layout>
    </v-layout>
    <v-slide-y-transition>
      <div v-if="!mostrarComenzarConfiguracion && !borradoDeFuera">
        <v-layout
          :column="$vuetify.breakpoint.smAndDown" :justify-start="$vuetify.breakpoint.smAndDown"
        >
          <v-flex xs5>
            <v-layout column justify-start>
              <v-layout v-if="!$vuetify.breakpoint.smAndDown" column justify-start>
                <o-thin-title>
                  {{$t('configuracion.modulosDisponibles')}}
                </o-thin-title>
                <p class="px-1 grey--text">
                  {{$t('configuracion.modulosDisponiblesTexto')}}
                </p>
                <v-layout justify-space-between align-center>
                  <v-flex>
                    <v-card class="px-2 py-1 mb-3 mr-3">
                      <draggable 
                        v-model="modulosComputed" 
                        :group="{
                          name: 'modulos-'.concat(alquiler ? 'alquiler' : 'venta'),
                          pull: todosBaseMetidos ? false : 'clone',
                          put: putBase
                        }"
                        :sort="false"
                        draggable=".draggable-item"
                        @start="onStartBase"
                        @end="onEndBase"
                        :move="onMoveBase"
                        :clone="onCloneBase"
                        id="base"
                      >
                        <v-card
                          :class="['pa-1', 'ma-2', 'draggable-item', 'modulo-base-item']"
                          v-for="(modulo, index) in modulosComputed"
                          :key="index + '-baseMod'"
                        >
                          <v-card>
                            <v-layout row justify-start align-center>
                              <o-tint-img
                                class="modulo-image"
                                :src="require('@/assets/images/reserva/' + modulo.tipo + '.jpg')"
                              />
                              <span :class="['modulo-text', 'pl-2', existeModulo(modulo.tipo) ? 'grey--text' : 'primary--text']">
                                {{getNombreModulo(modulo.tipo)}}
                              </span>
                            </v-layout>
                          </v-card>
                          <v-card v-if="modulo.tipo === 'kyc'" class="mt-2">
                            <v-layout row justify-start align-center>
                              <o-tint-img
                                class="modulo-image"
                                :src="require('@/assets/images/reserva/' + moduloDocumentacionBase.tipo + '.jpg')"
                              />
                              <span :class="['modulo-text', 'pl-2', existeModulo(modulo.tipo) ? 'grey--text' : 'primary--text']">
                                {{getNombreModulo('documentacion')}}
                              </span>
                            </v-layout>
                          </v-card>
                        </v-card>
                      </draggable>
                    </v-card>
                  </v-flex>
                  <v-layout column shrink>
                    <v-icon medium class="primary--text">arrow_forward</v-icon>
                    <v-icon medium class="primary--text">arrow_back</v-icon>
                  </v-layout>
                </v-layout>
              </v-layout>
              <v-layout column justify-start>
                <o-thin-title>
                  {{$t('configuracion.tiempoMax')}}
                </o-thin-title>
                <div class="px-1 grey--text">
                  {{$t('configuracion.tiempoMaxTexto')}}
                </div>
                <v-layout>
                  <v-text-field
                    v-model="horasCaducar"
                    :suffix="' ' + $t('general.misc.horas')"
                    style="min-width: 80px; max-width: 130px"
                    class="px-2"
                    :rules="[rules.integerNumber0,rules.menor(10000)]"
                  />
                </v-layout>
                <p class="px-1 grey--text">
                  {{$t('configuracion.tiempoMaxDescripcion')}}
                </p>
                <p class="px-1 grey--text">
                  {{$t('configuracion.tiempoMaxDescripcionDos')}}
                </p>
                <p class="px-1 grey--text">
                  {{$t('configuracion.tiempoMaxDescripcionTres')}}
                </p>
              </v-layout>
              <v-layout column v-if="alquiler">
                <o-thin-title>
                  {{$t('configuracion.scoring')}}
                </o-thin-title>
                <p class="px-1 grey--text">
                  {{$t('configuracion.scoringTexto')}}
                </p>
                <v-layout mx-2 >
                  <v-checkbox
                    color="primary"
                    class="grey--text pl-2 mt-0" 
                    v-model="scoring" 
                    :label="$t('configuracion.scoringLabel')"
                  >
                  </v-checkbox>
                </v-layout>
              </v-layout>
              <v-layout column>
                <o-thin-title>
                  {{$t('configuracion.metodosPago')}}
                </o-thin-title>
                <p class="px-1 grey--text">
                  {{$t('configuracion.metodosPagoTexto')}}
                </p>
                <v-layout mx-2 pb-3>
                  <v-select
                    hide-details
                    v-model="modoPago"
                    :items="tiposPago"
                    :label="$t('configuracion.metodosPago')"
                    item-text="nombre"
                    item-value="valor"
                    :rules="[rules.required]"
                  />
                </v-layout>
              <v-layout>
                <v-checkbox 
                  color="primary"
                  class="grey--text pl-2" 
                  v-model="capturarPago" 
                  :label="$t('configuracion.pagoInmediato')"
                  :disabled="modoPago === 'transferencia'"
                >
                  <template slot="label">
                    {{$t('configuracion.pagoInmediato')}}
                    <v-tooltip max-width="320" bottom>
                      <template #activator="{on}">
                        <v-icon class="pl-1 pb-2" small v-on="on" @click.stop>
                          info
                        </v-icon>
                      </template>
                      <span>{{$t('configuracion.pagoTooltip')}}</span>
                    </v-tooltip>
                  </template>
                </v-checkbox>
              </v-layout>
              </v-layout>
              <v-layout column v-if="!alquiler">
                <o-thin-title>
                  {{$t('configuracion.kyc')}}
                </o-thin-title>
                <p class="px-1 grey--text">
                  {{$t('configuracion.kycTexto')}}
                </p>
                <v-layout>
                  <v-checkbox
                    color="primary"
                    class="grey--text pl-2 mt-0" 
                    v-model="firmarKYC" 
                    :label="$t('configuracion.kycLabel')"
                  >
                    <!-- <template slot="label">
                      El cliente debe firmar el formulario de datos
                      <v-tooltip bottom>
                        <template #activator="{on}">
                          <v-icon class="pl-1 pb-2" small v-on="on" @click.stop>
                            info
                          </v-icon>
                        </template>
                        <span>Si marca esta casilla el cliente tendrá que firmar digitalmente un documento con los datos introducidos.</span>
                      </v-tooltip>
                    </template> -->
                  </v-checkbox>
                </v-layout>
              </v-layout>
              <v-layout column v-if="!alquiler && existeModulo('pbc')">
                <o-thin-title>
                  {{$t('configuracion.validacionPbc')}}
                </o-thin-title>
                <p class="px-1 grey--text">
                  {{$t('configuracion.validacionPbcTexto')}}
                </p>
                <v-layout>
                  <v-checkbox
                    color="primary"
                    class="grey--text pl-2 mt-0" 
                    v-model="validarPbcDesdeBO" 
                    :label="$t('configuracion.validacionPbcLabel')"
                  >
                  </v-checkbox>
                </v-layout>
              </v-layout>
              <v-layout column v-if="existeModulo('kyc')">
                <o-thin-title>
                  {{$t('configuracion.documentacionFlexible')}}
                </o-thin-title>
                <p class="px-1 grey--text">
                  {{$t('configuracion.documentacionFlexibleTexto')}}
                </p>
                <v-layout>
                  <v-checkbox
                    color="primary"
                    class="grey--text pl-2 mt-0" 
                    v-model="aportarDocumentosFormaFlexible" 
                    :label="$t('configuracion.documentacionFlexibleLabel')"
                  >
                  </v-checkbox>
                </v-layout>
              </v-layout>
              <v-layout column v-if="mostrarConfigDocMorosidad">
                <o-thin-title>
                  {{$t('configuracion.documentoMorosidad')}}
                </o-thin-title>
                <span class="px-1 mb-1 grey--text">
                  {{$t('configuracion.documentoMorosidadTexto')}}
                </span>
                <v-layout>
                  <v-checkbox
                    v-model="documentoMorosidadOpcional" 
                    :label="$t('configuracion.documentoMorosidadOpcional')"
                    hide-details
                    color="primary"
                    class="grey--text pl-2 mt-0" 
                  >
                  </v-checkbox>
                </v-layout>
                <v-layout>
                  <v-checkbox
                    v-model="documentoMorosidadVisible" 
                    :label="$t('configuracion.documentoMorosidadVisible')"
                    hide-details
                    color="primary"
                    class="grey--text pl-2 mt-0 pb-2" 
                  >
                  </v-checkbox>
                </v-layout>
                <span class="px-1 py-1 grey--text">
                  {{$t('configuracion.documentoMorosidadEditar')}}
                </span>
                <v-layout>
                  <v-text-field
                    :value="$t('mixins.documentacion.morosidad')"
                    :label="$t('configuracion.documentoMorosidadTituloDefecto')"
                    disabled
                    class="px-2"
                  />
                </v-layout>
                <v-layout>
                  <v-text-field
                    v-model="documentoMorosidadTitulo"
                    :label="$t('configuracion.documentoMorosidadEditarTitulo')"
                    class="px-2"
                  />
                </v-layout>
              </v-layout>
            </v-layout>
          </v-flex>
          <v-flex xs7 :class="!$vuetify.breakpoint.smAndDown ? 'pl-4' : ''">
            <v-layout column justify-start>
              <o-thin-title>
                {{$t('configuracion.miConfiguracion')}}
              </o-thin-title>
              <p class="px-1 grey--text">
               {{$t('configuracion.miConfiguracionTexto')}} 
              </p>
              <v-card class="px-2 py-1">
                <v-layout
                  row justify-start align-start
                >
                  <v-flex
                    v-if="!$vuetify.breakpoint.xsOnly"
                    style="min-width: 50px" 
                    shrink
                  >
                    <v-layout
                      v-for="i in amountPreModulosConAux+1"
                      :key="i + '-pre'"
                      row justify-start align-center
                      :class="[i === 1 ? 'grey--text' : 'primary--text', 'ml-2', i === 2 ?  'mt-3' : 'mt-2']"
                      style="height: 102px"
                    >
                      <h1 style="align-text:right">
                        {{(i) + ' - '}}
                      </h1>
                    </v-layout>
                  </v-flex>
                  <v-flex
                    :style="{
                      position: 'relative'
                    }"
                  >
                    <v-card class="pa-2 mx-3 ma-2 modulo-reserva-item">
                      <v-card class="pr-2">
                        <v-layout column>
                          <v-layout row justify-start align-center>
                            <o-tint-img
                              class="modulo-image hidden-xs-only"
                              :src="require('@/assets/images/reserva/' + moduloCondiciones.tipo + '.jpg')"
                            />
                            <v-text-field 
                              :style="$vuetify.breakpoint.smAndDown ? 'max-width: 350px' : ''"
                              :label="getTexto('modulos.condiciones' + (alquiler ? 'Alquiler' : ''))"
                              :value="getNombreModulo('condiciones')"                      
                              class="pl-2 my-1"
                              readonly
                            />
                          </v-layout>
                        </v-layout>
                      </v-card>
                    </v-card>
                    <v-layout
                      v-if="amountPreModulosConAux === 0  && ($vuetify.breakpoint.mdAndUp || !todoVacio)"
                      class="pa-2 mx-2 modulo-reserva-item draggable-empty"
                      row justify-center align-center
                      :style="{
                        position: 'absolute',
                        right: '0',
                        left: '0',
                        pointerEvents: 'none'
                      }"
                    >
                      <span class="primary--text modulo-text">
                        {{$t('configuracion.arrastreModulos')}}
                      </span>
                    </v-layout>
                    <draggable 
                      v-if="$vuetify.breakpoint.mdAndUp || !todoVacio"
                      v-model="modulosPreReserva"
                      :group="{
                        name: 'modulos-'.concat(alquiler ? 'alquiler' : 'venta')
                      }"
                      draggable=".draggable-item"
                      style="min-height: 82px"
                      class="draggable-empty ma-2"
                      @start="onStartPre"
                      @end="onEnd"
                      :move="onMove"
                      id="pre"
                    >
                      <v-card
                        v-for="(modulo) in modulosPreReserva"
                        :key="(modulo.tipo) + '-pre'"
                        class="draggable-item pa-2 ma-2 modulo-reserva-item"
                      >
                        <v-card :class="$vuetify.breakpoint.xsOnly ? '' : 'pr-2'">
                          <v-layout column>
                            <v-layout row justify-space-between align-center>
                              <v-layout row justify-start align-center>
                                <o-tint-img
                                  class="modulo-image hidden-xs-only"
                                  :src="require('@/assets/images/reserva/' + modulo.tipo + '.jpg')"
                                />
                                <v-text-field 
                                  :style="$vuetify.breakpoint.smAndDown ? 'max-width: 350px' : ''"
                                  :label="getNombreModulo(modulosComputed.find(x => x.tipo === modulo.tipo).tipo)"
                                  :value="getNombreModulo(modulo.tipo)"
                                  :rules="getRulesModulo(modulo.tipo)"     
                                  class="pl-2 my-1"
                                  readonly
                                />
                              </v-layout>
                              <v-btn
                                v-if="$vuetify.breakpoint.smAndDown"
                                @click="removeModulo(modulosPreReserva, modulo.tipo)" :title="$t('configuracion.eliminarModulo')"
                                icon :class="$vuetify.breakpoint.xsOnly ? 'ma-0 mr-1' : 'mr-2'"
                              >
                                <v-icon medium class="primary--text">remove_circle_outline</v-icon>
                              </v-btn>
                            </v-layout>
                          </v-layout>
                        </v-card>
                        <v-card v-if="modulo.tipo === 'kyc'" :class="['mt-4', $vuetify.breakpoint.xsOnly ? '' : 'pr-2']">
                          <v-layout column>
                            <v-layout row justify-start align-center>
                              <o-tint-img
                                class="modulo-image hidden-xs-only"
                                :src="require('@/assets/images/reserva/' + moduloDocumentacion.tipo + '.jpg')"
                              />
                              <v-text-field 
                                :style="$vuetify.breakpoint.smAndDown ? 'max-width: 350px' : ''"
                                :label="getNombreModulo('documentacion')"
                                :value="getNombreModulo('documentacion')"
                                :rules="[rules.required, rules.max(255)]"   
                                class="pl-2 pr-4 my-1"
                                readonly
                              />
                            </v-layout>
                          </v-layout>
                        </v-card>
                      </v-card>
                    </draggable>
                  </v-flex>
                </v-layout>
                <v-layout 
                  v-if="$vuetify.breakpoint.smAndDown" 
                  :justify-center="$vuetify.breakpoint.xsOnly"
                  :justify-end="$vuetify.breakpoint.smAndUp"
                >
                  <v-btn
                    :disabled="todosBaseMetidos"
                    @click="openAddModulo(true)"
                    color="primary"
                    large :class="$vuetify.breakpoint.xsOnly ? '' : 'mr-4 my-2'"
                  >
                    <span>{{$t('configuracion.addModulo')}}</span>
                    <v-icon class="ml-2" medium>add_circle_outline</v-icon>
                  </v-btn>
                </v-layout>
                <v-card class="flex grey--text pa-2 ma-2">
                  {{$t('configuracion.reservadoTexto')}}
                  <!-- eslint-disable-next-line -->
                  {{hayHorasCaducar ? $t('configuracion.disponeHoras', {horas: horasCaducar}) : ''}}
                </v-card>
                <v-layout
                  row justify-start align-start
                >
                  <v-flex
                    v-if="!$vuetify.breakpoint.xsOnly"
                    style="min-width: 50px" 
                    shrink
                  >
                    <v-layout
                      v-for="i in amountPostModulosConAux"
                      :key="i + '-post'"
                      row justify-start align-center
                      :class="['ml-2', i === 1 ?  'mt-3' : 'mt-2']"
                      style="height: 102px"
                    >
                      <h1 class="primary--text" style="align-text:right">
                        {{(i+amountPreModulosConAux+1) + ' - '}}
                      </h1>
                    </v-layout>
                  </v-flex>
                  <v-flex
                    :style="{
                      position: 'relative'
                    }"
                  >
                    <v-layout
                      v-if="amountPostModulosConAux === 0 && ($vuetify.breakpoint.mdAndUp || !todoVacio)"
                      class="pa-2 ma-2 modulo-reserva-item draggable-empty"
                      row justify-center align-center
                      :style="{
                        position: 'absolute',
                        right: '0',
                        left: '0',
                        pointerEvents: 'none'
                      }"
                    >
                      <span class="primary--text modulo-text">
                        {{$t('configuracion.arrastreModulos')}}
                      </span>
                    </v-layout>
                    <draggable 
                      v-if="$vuetify.breakpoint.mdAndUp || !todoVacio"
                      v-model="modulosPostReserva"
                      :group="{
                        name: 'modulos-'.concat(alquiler ? 'alquiler' : 'venta')
                      }"
                      draggable=".draggable-item"
                      style="min-height: 82px"
                      class="draggable-empty ma-2"
                      @start="onStartPost"
                      @end="onEnd"
                      :move="onMove"
                      id="post"
                    >
                      <v-card
                        v-for="(modulo) in modulosPostReserva"
                        :key="(modulo.tipo) + '-pre'"
                        class="draggable-item pa-2 ma-2 modulo-reserva-item"
                      >
                        <v-card :class="$vuetify.breakpoint.xsOnly ? '' : 'pr-2'">
                          <v-layout column>
                            <v-layout row justify-space-between align-center>
                              <v-layout row justify-start align-center>
                                <o-tint-img
                                  class="modulo-image hidden-xs-only"
                                  :src="require('@/assets/images/reserva/' + modulo.tipo + '.jpg')"
                                />
                                <v-text-field 
                                  :style="$vuetify.breakpoint.smAndDown ? 'max-width: 350px' : ''"
                                  :label="getNombreModulo(modulosComputed.find(x => x.tipo === modulo.tipo).tipo)"
                                  :value="getNombreModulo(modulo.tipo)"
                                  :rules="getRulesModulo(modulo.tipo)"      
                                  class="pl-2 my-1"
                                  readonly
                                />
                              </v-layout>
                              <v-btn
                                v-if="$vuetify.breakpoint.smAndDown"
                                @click="removeModulo(modulosPostReserva, modulo.tipo)" :title="$t('configuracion.eliminarModulo')"
                                icon :class="$vuetify.breakpoint.xsOnly ? 'ma-0 mr-1' : 'mr-2'"
                              >
                                <v-icon medium class="primary--text">remove_circle_outline</v-icon>
                              </v-btn>
                            </v-layout>
                          </v-layout>
                        </v-card>
                        <v-card v-if="modulo.tipo === 'kyc'" :class="['mt-4', $vuetify.breakpoint.xsOnly ? '' : 'pr-2']">
                          <v-layout column>
                            <v-layout row justify-start align-center>
                              <o-tint-img
                                class="modulo-image hidden-xs-only"
                                :src="require('@/assets/images/reserva/' + moduloDocumentacion.tipo + '.jpg')"
                              />
                              <v-text-field 
                                :style="$vuetify.breakpoint.smAndDown ? 'max-width: 350px' : ''"
                                :label="getNombreModulo('documentacion')"
                                :value="getNombreModulo('documentacion')"
                                class="pl-2 pr-4 my-1"
                                readonly
                              />
                            </v-layout>
                          </v-layout>
                        </v-card>
                      </v-card>
                    </draggable>
                  </v-flex>
                </v-layout>
                <v-layout 
                  v-if="$vuetify.breakpoint.smAndDown"
                  :justify-center="$vuetify.breakpoint.xsOnly"
                  :justify-end="$vuetify.breakpoint.smAndUp"
                >
                  <v-btn
                    :disabled="todosBaseMetidos"
                    @click="openAddModulo(false)"
                    color="primary"
                    large :class="$vuetify.breakpoint.xsOnly ? '' : 'mr-4 my-2'"
                  >
                    <span>{{$t('configuracion.addModulo')}}</span>
                    <v-icon class="ml-2" medium>add_circle_outline</v-icon>
                  </v-btn>
                </v-layout>
              </v-card>
            </v-layout>
          </v-flex>
          <v-fade-transition>
            <custom-dialog v-if="mostrarPopUpAddModulos" v-model="mostrarPopUpAddModulos">
              <PopUpAddModulos @add="addModulos" :modulos="modulosParaPopUp" :moduloDocumentacion="moduloDocumentacionBase"/>
            </custom-dialog>
          </v-fade-transition>
        </v-layout>
        <v-layout justify-center pt-4>
          <v-btn 
            :disabled="!cambiado || guardando"
            :loading="guardando"
            @click="guardarModulos()"
            large color="primary"
          >
              {{$t('general.misc.guardarCambios')}}
          </v-btn>
        </v-layout>
      </div>
    </v-slide-y-transition>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import draggable from 'vuedraggable'
import rulesMixin from '@/mixins/rules.js'
import PopUpAddModulos from '@/components/configuracion/PopUpAddModulos'

export default {
  mixins: [rulesMixin],
  components: {
    draggable,
    PopUpAddModulos
  },
  props: {
    alquiler: {
      default: false,
      type: Boolean
    },
    borradoDeFuera: {
      default :false,
      type: Boolean
    },
    codigoPromocion: {
      default: null,
      type: String
    }
  },
  data () {
    return {
      modulosPreReserva: [],
      modulosPostReserva: [],
      horasCaducar: '168',
      horasCaducarBase: '168',
      scoring: false,
      scoringBase: false,
      capturarPago: false,
      capturarPagoBase: false,
      valid: false,
      putBase: false,
      moduloAgarrado: {},
      indexModuloAgarrado: 0,
      auxModulosPre: 0,
      auxModulosPost: 0,
      mostrarPopUpAddModulos: false,
      addModulosEnPreReserva: false,
      guardando: false,
      cambiadoData: false,
      mostrarComenzarConfiguracion: false,
      modoPago: 'ambos',
      firmarKYC: false,
      validarPbcDesdeBO: false,
      aportarDocumentosFormaFlexible: false,
      documentoMorosidadOpcional: false,
      documentoMorosidadVisible: false,
      documentoMorosidadTitulo: '',
      moduloDocumentacion: {
        tipo: 'documentacion',
        nombre: this.$t('configuracion.moduloDoc'),
        creaReserva: false
      },
      moduloCondiciones: {
        tipo: 'condiciones',
        nombre: this.$t('configuracion.moduloCondiciones'),
        creaReserva: false
      }
    }
  },
  created () {
    this.inicializar()
  },
  computed: {
    ...mapGetters({
      modulosOrdenStore: 'modulosOrdenes/getByAlquiler',
      modulosStore: 'modulosOrdenes/modulos/getAllByModulosOrdenId'
    }),
    modulosOrden () {
      return this.modulosOrdenStore({alquiler: this.alquiler, simplificada: 0, codigoPromocion: this.codigoPromocion})
    },
    modulos () {
      return this.modulosOrden ? this.modulosStore(this.modulosOrden.id) : []
    },
    modulosBase () {
      return [
        {
          tipo: 'pago',
          nombre: this.$t('configuracion.moduloPago'),
          creaReserva: false
        },
        {
          tipo: 'contrato',
          nombre: this.$t('configuracion.moduloContrato'),
          creaReserva: false
        },
        {
          tipo: 'kyc',
          nombre: this.$t('configuracion.moduloKyc'),
          creaReserva: false
        },
        {
          tipo: 'validacionDocumentacion',
          nombre: this.$t('configuracion.moduloValidacion'),
          creaReserva: false
        }
      ]
    },
    moduloPbcBase () {
      return {
        tipo: 'pbc',
        nombre: this.$t('configuracion.moduloPbc'),
        creaReserva: false
      }
    },
    moduloDocumentacionBase() {
      return {
        tipo: 'documentacion',
        nombre: this.$t('configuracion.moduloDoc'),
        creaReserva: false
      }
    },
    moduloCondicionesBase () {
      return {
        tipo: 'condiciones',
        nombre: this.$t('configuracion.moduloCondiciones'),
        creaReserva: false
      }
    },
    tiposPago() {
      return [
        {
          nombre: this.$t('configuracion.pagoTarjeta'),
          valor: 'stripe'
        },
        {
          nombre: this.$t('configuracion.pagoTransfer'),
          valor: 'transferencia'
        },
        {
          nombre: this.$t('configuracion.pagoTarjetaTransfer'),
          valor: 'ambos'
        }
      ]
    },
    modulosComputed: {
      get () {
        return this.alquiler ? this.modulosBase : this.modulosBase.concat(this.moduloPbcBase)
      },
      set () {
      }
    },
    hayHorasCaducar () {
      return this.horasCaducar && this.horasCaducar !== '0' && Number.isInteger(Number(this.horasCaducar))
    },
    modulosParaPopUp () {
      return this.modulosComputed.map(x => {
        return {
          ...x,
          disponible: !this.existeModulo(x.tipo)
        }
      })
    },
    todoVacio () {
      return this.amountPreModulos === 0 && this.amountPostModulos === 0
    },
    amountPreModulosConAux () {
      const amount = this.amountPreModulos + this.auxModulosPre
      return amount >= 0 ? amount : 0
    },
    amountPreModulos () {
      return Math.max(0, this.modulosPreReserva.length +
        (this.modulosPreReserva.some(x => x.tipo === 'kyc') ? 1 : 0))
    },
    amountPostModulosConAux () {
      const amount = this.amountPostModulos + this.auxModulosPost
      return amount >= 0 ? amount : 0
    },
    amountPostModulos () {
      return Math.max(0, this.modulosPostReserva.length +
        (this.modulosPostReserva.some(x => x.tipo === 'kyc') ? 1 : 0))
    },
    todosBaseMetidos () {
      return this.modulosComputed.every(x => this.existeModulo(x.tipo))
    },
    cantidadModulosTotal () {
      return Math.max(0, this.modulosPrePostJuntos.length +
        (this.modulosPrePostJuntos.some(x => x.tipo === 'kyc') ? 1 : 0))
    },
    hayModulos () {
      return (this.modulosPreReserva.length > 0 || this.modulosPostReserva.length > 0)
    },
    cambiado () {
      // si cambiadoData ya es true, la cantidad de módulos es distinta a la inicial o
      // las variables básicas son distintas paramos la ejecución y devolvemos true
      if (this.cambiadoData || this.variablesBasicasCambiadas || this.cantidadModulosTotal !== this.modulos.filter(x => x.tipo !== 'condiciones').length) {
        // eslint-disable-next-line
        this.cambiadoData = true
        return this.cambiadoData
      }
      let i = 0
      // comprobamos si se ha cambiado el nombre del módulo de condiciones
      // eslint-disable-next-line
      // comprobamos si el indice del módulo que crea la reserva es distinto a la cantidad de módulos preReserva
      // para saber si sigue estando en el mismo lugar o la distribución de los módulos ha cambiado
      // eslint-disable-next-line
      this.cambiadoData = this.cambiadoData || (this.modulosOrden != null && this.modulos.findIndex(x => x.creaReserva) !== this.amountPreModulos)
      // antes de comenzar con el loop comprobamos si ha cambiado para parar la ejecución en ese caso
      if (this.cambiadoData) {
        return true
      }
      if (this.modulosOrden != null) {
        if (this.modulosOrden.tiposPago !== this.modoPago) {
          // eslint-disable-next-line
          this.cambiadoData = true
        }
        if (this.modulosOrden.generarContratoKyc !== this.firmarKYC) {
          // eslint-disable-next-line
          this.cambiadoData = true
        }
        if (this.modulosOrden.validarPbcDesdeBO !== this.validarPbcDesdeBO) {
          // eslint-disable-next-line
          this.cambiadoData = true
        }
        if (this.modulosOrden.aportarDocumentosFormaFlexible !== this.aportarDocumentosFormaFlexible) {
          // eslint-disable-next-line
          this.cambiadoData = true
        }
        if (this.modulosOrden.documentoMorosidadVisible !== this.documentoMorosidadVisible) {
          // eslint-disable-next-line
          this.cambiadoData = true
        }
        if (this.modulosOrden.documentoMorosidadOpcional !== this.documentoMorosidadOpcional) {
          // eslint-disable-next-line
          this.cambiadoData = true
        }
        if (this.modulosOrden.documentoMorosidadTitulo !== this.documentoMorosidadTitulo) {
          // eslint-disable-next-line
          this.cambiadoData = true
        }
        i++
        // loopeamos en los módulos para comprobar
        this.modulosPrePostJuntos.forEach(modulo => {
          // - si el tipo del módulo es distinto al que está en su misma posición del array de la store
          if (modulo.tipo !== this.modulos[i].tipo) {
            // eslint-disable-next-line
            this.cambiadoData = true
          } else {
            // - si el tipo está bien comprobamos si el usuario ha modificado el nombre
            // - si el tipo del módulo actual es kyc hacemos la misma comprobación de antes con la documentación
            if (modulo.tipo === 'kyc') {
              i++
              if (this.moduloDocumentacion.tipo !== this.modulos[i].tipo) {
                // eslint-disable-next-line
                this.cambiadoData = true
              }
            }
          }
          i++
          // en cada iteración, si ha cambiado devolvemos true
          if (this.cambiadoData) {
            return true
          }
        })
      }
      return this.cambiadoData
    },
    modulosPrePostJuntos () {
      return this.modulosPreReserva.concat(this.modulosPostReserva)
    },
    variablesBasicasCambiadas () {
      return this.cambiadoData ||
        this.horasCaducar !== this.horasCaducarBase ||
        this.capturarPago !== this.capturarPagoBase ||
        this.scoring !== this.scoringBase
    },
    mostrarConfigDocMorosidad () {
      return this.existeModulo('kyc') && this.alquiler && !this.aportarDocumentosFormaFlexible
    }
  },
  methods: {
    ...mapActions({
      guardarModulosOrden: 'modulosOrdenes/crear',
      addAlert: 'alerts/add'
    }),
    getNombreModulo(tipo) {
      return this.getTexto('modulos.' + tipo + (this.alquiler ? 'Alquiler' : ''))
    },
    inicializar () {
      if (this.modulosOrden != null) {
        this.horasCaducar = this.modulosOrden.horasCaducar === null ? '0' : this.modulosOrden.horasCaducar.toString()
        this.horasCaducarBase = this.horasCaducar
        this.capturarPago = this.modulosOrden.capturarPago
        this.capturarPagoBase = this.capturarPago
        this.scoring = this.modulosOrden.scoring
        this.scoringBase = this.scoring
        this.modoPago = this.modulosOrden.tiposPago
        this.firmarKYC = this.modulosOrden.generarContratoKyc
        this.validarPbcDesdeBO = this.modulosOrden.validarPbcDesdeBO
        this.aportarDocumentosFormaFlexible = this.modulosOrden.aportarDocumentosFormaFlexible
        this.documentoMorosidadVisible = this.modulosOrden.documentoMorosidadVisible
        this.documentoMorosidadOpcional = this.modulosOrden.documentoMorosidadOpcional
        this.documentoMorosidadTitulo = this.modulosOrden.documentoMorosidadTitulo
        this.inicializarModulos()
      } else {
        this.mostrarComenzarConfiguracion = true
      }
    },
    comenzarConfiguracion () {
      this.$emit('resetBorrado', this.alquiler)
      this.cambiadoData = true
      this.mostrarComenzarConfiguracion = false
    },
    alertPreRefresh (e) {
      if (this.cambiado) {
        let message = this.$t('general.misc.alertPreRefresh')
        e = e || window.event
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      }
    },
    getRulesModulo (tipo) {
      let rulesModulo = []
      if (tipo === 'validacionDocumentacion') {
        rulesModulo = rulesModulo.concat(this.validacionCorrecta)
      } else if (tipo === 'contrato') {
        rulesModulo = rulesModulo.concat(this.contratoCorrecto)
      } else if (!this.alquiler && tipo === 'pbc') {
        rulesModulo = rulesModulo.concat(this.pbcCorrecto)
      }
      return rulesModulo
    },
    validacionCorrecta () {
      // buscamos el index de la validación de documentación
      const validacionIndex = this.modulosPrePostJuntos.findIndex(x => x.tipo === 'validacionDocumentacion')
      // buscamos el index del kyc (mismo que el de la documentación)
      const kycIndex = this.modulosPrePostJuntos.findIndex(x => x.tipo === 'kyc')
      if (validacionIndex === -1 || (kycIndex !== -1 && validacionIndex > kycIndex)) {
        return true
      } else {
        return this.$t('configuracion.avisoModuloOrden', {nombre: this.getNombreModulo('documentacion')})
      }
    },
    contratoCorrecto () {
      // buscamos el index de la validación de documentación
      const validacionIndex = this.modulosPrePostJuntos.findIndex(x => x.tipo === 'validacionDocumentacion')
      // buscamos el index del kyc (mismo que el de la documentación)
      const kycIndex = this.modulosPrePostJuntos.findIndex(x => x.tipo === 'kyc')
      // buscamos el index del kyc (mismo que el de la documentación)
      const contratoIndex = this.modulosPrePostJuntos.findIndex(x => x.tipo === 'contrato')
      if (validacionIndex === -1 || (kycIndex !== -1 && contratoIndex > kycIndex)) {
        return true
      } else {
        return this.$t('configuracion.avisoModuloOrden', {nombre: this.getNombreModulo('documentacion')})
      }
    },
    pbcCorrecto () {
      // buscamos el index del pbc
      const pbcIndex = this.modulosPrePostJuntos.findIndex(x => x.tipo === 'pbc')
      // buscamos el index del kyc (mismo que el de la documentación)
      const kycIndex = this.modulosPrePostJuntos.findIndex(x => x.tipo === 'kyc')
      // buscamos el index del validacionDocumentacion
      const validacionIndex = this.modulosPrePostJuntos.findIndex(x => x.tipo === 'validacionDocumentacion')
      if (pbcIndex === -1) {
        return true
      }
      if (this.validarPbcDesdeBO) {
        const creaReservaIndex = this.modulosPrePostJuntos.findIndex(x => x.tipo === this.modulosPreReserva[this.modulosPreReserva.length - 1].tipo)
        if (pbcIndex - creaReservaIndex != 1) {
          return this.$t('configuracion.avisoValidarPbcBO')
        }
      }
      if (kycIndex === -1) {
        return this.$t('configuracion.avisoModuloOrden', {nombre: this.getNombreModulo('documentacion')})
      }
      if (validacionIndex === -1) {
        if (pbcIndex > kycIndex) {
          return true
        } else {
          return this.$t('configuracion.avisoModuloOrden', {nombre: this.getNombreModulo('documentacion')})
        }
      } else {
        if (pbcIndex > kycIndex) {
          if (pbcIndex > validacionIndex) {
            return true
          } else {
            return this.$t('configuracion.avisoModuloOrden', {nombre: this.getNombreModulo(this.modulosPrePostJuntos[validacionIndex].tipo)})
          }
        } else {
          return this.$t('configuracion.avisoModuloOrden', {nombre: this.getNombreModulo('documentacion')})
        }
      }
    },
    inicializarModulos () {
      const indexToSplit = this.modulos.findIndex(x => x.creaReserva)
      this.moduloCondiciones = Object.assign({}, this.modulos[0])
      this.moduloCondiciones.creaReserva = this.moduloCondicionesBase.creaReserva
      if (this.modulos.some(x => x.tipo === 'documentacion')) {
        this.moduloDocumentacion = Object.assign({}, this.modulos.find(x => x.tipo === 'documentacion'))
        this.moduloDocumentacion.creaReserva = false
      }
      this.modulosPreReserva = this.modulos.slice(1, indexToSplit + 1).filter(x => x.tipo !== 'documentacion')
        .map(x => {
          return {
            tipo: x.tipo,
            nombre: x.nombre,
            creaReserva: false
          }
        })
      this.modulosPostReserva = this.modulos.slice(indexToSplit + 1).filter(x => x.tipo !== 'documentacion')
        .map(x => {
          return {
            tipo: x.tipo,
            nombre: x.nombre,
            creaReserva: false
          }
        })
    },
    async guardarModulos () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
        return
      }
      try {
        this.guardando = true
        let modulosObject = this.modulosPreReserva.map(x => {
          return {...x}
        })
        modulosObject.splice(0, 0, this.moduloCondiciones)
        let indexKyc = -1
        // buscamos el kyc en los módulos pre reserva para añadirle el objeto de documentación
        if (modulosObject.some(x => x.tipo === 'kyc')) {
          indexKyc = modulosObject.findIndex(x => x.tipo === 'kyc')
          modulosObject.splice(indexKyc + 1, 0, this.moduloDocumentacion)
        }
        // asignamos el creaReserva al último módulo añadido hasta ahora
        modulosObject[modulosObject.length - 1].creaReserva = true
        // unimos los módulos post reserva al final
        modulosObject = modulosObject.concat(this.modulosPostReserva)
        // en caso de indexKyc === -1 (no se ha encontrado el objeto)
        // volvemos a buscar el objeto kyc para añadirle el objeto de documentación
        if (indexKyc === -1 && modulosObject.some(x => x.tipo === 'kyc')) {
          indexKyc = modulosObject.findIndex(x => x.tipo === 'kyc')
          modulosObject.splice(indexKyc + 1, 0, this.moduloDocumentacion)
        }
        const objetoParaApi = {
          horasCaducar: this.horasCaducar === '0' ? null : Number(this.horasCaducar),
          capturarPago: this.capturarPago,
          alquiler: this.alquiler ? 1 : 0,
          scoring: this.scoring ? 1 : 0,
          modulos: modulosObject,
          simplificada: false,
          codigoPromocion: this.codigoPromocion,
          tiposPago: this.modoPago,
          generarContratoKyc: this.firmarKYC,
          validarPbcDesdeBO: this.existeModulo('pbc') ? this.validarPbcDesdeBO : false,
          aportarDocumentosFormaFlexible: this.existeModulo('kyc') ? this.aportarDocumentosFormaFlexible : false,
          documentoMorosidadVisible: this.mostrarConfigDocMorosidad ? this.documentoMorosidadVisible : true,
          documentoMorosidadOpcional: this.mostrarConfigDocMorosidad ? this.documentoMorosidadOpcional : false,
          documentoMorosidadTitulo: this.mostrarConfigDocMorosidad ? this.documentoMorosidadTitulo : ''
        }
        await this.guardarModulosOrden(objetoParaApi)
        this.inicializar()
        this.guardando = false
        this.cambiadoData = false
        this.addAlert({texto: this.$t('general.misc.datosGuardadosExito'), color: 'success'})
      } catch (error) {
        this.guardando = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    existeModulo (tipo) {
      return this.modulosPrePostJuntos.some(x => x.tipo === tipo)
    },
    removeModulo (array, tipo) {
      const index = array.findIndex(x => x.tipo === tipo)
      array.splice(index, 1)
      this.$refs.form.validate()
    },
    openAddModulo (zona) {
      this.addModulosEnPreReserva = zona
      this.mostrarPopUpAddModulos = true
    },
    addModulos (modulos) {
      this.mostrarPopUpAddModulos = false
      if (this.addModulosEnPreReserva) {
        this.modulosPreReserva = this.modulosPreReserva.concat(modulos)
      } else {
        this.modulosPostReserva = this.modulosPostReserva.concat(modulos)
      }
      this.$refs.form.validate()
    },
    onStartBase (e) {
      let moduloCogido = this.modulosComputed[e.oldIndex]
      this.indexModuloAgarrado = e.oldIndex
      this.moduloAgarrado = moduloCogido
    },
    onEndBase (e) {
      e.item.classList.add('modulo-base-item')
      e.item.classList.add('pa-1')
      e.item.classList.remove('pa-2')
      e.item.classList.remove('modulo-reserva-item')
      e.item.classList.remove('none')
      this.auxModulosPre = 0
      this.auxModulosPost = 0
      this.putBase = false
      this.$refs.form.validate()
    },
    onCloneBase (obj) {
      return {
        ...obj
      }
    },
    onMoveBase (e) {
      if (e.to.id === 'base') {
        e.dragged.classList.add('none')
      } else if (e.to.id === 'pre' || e.to.id === 'post') {
        this.putBase = true
        if (this.existeModulo(this.moduloAgarrado.tipo)) {
          return false
        } else {
          e.dragged.classList.remove('modulo-base-item')
          e.dragged.classList.remove('pa-1')
          e.dragged.classList.add('pa-2')
          e.dragged.classList.add('modulo-reserva-item')
        }
      }
      this.updateCantidadListas(e.from, e.to)
      return true
    },
    onStartPre (e) {
      let moduloCogido = this.modulosPreReserva[e.oldIndex]
      this.indexModuloAgarrado = e.oldIndex
      this.moduloAgarrado = moduloCogido
      this.putBase = true
    },
    onStartPost (e) {
      let moduloCogido = this.modulosPostReserva[e.oldIndex]
      this.indexModuloAgarrado = e.oldIndex
      this.moduloAgarrado = moduloCogido
      this.putBase = true
    },
    onMove (e) {
      if (e.to.id === 'base') {
        e.dragged.classList.add('none')
      }
      this.updateCantidadListas(e.from, e.to)
    },
    onEnd () {
      this.putBase = false
      this.auxModulosPre = 0
      this.auxModulosPost = 0
      this.$refs.form.validate()
    },
    updateCantidadListas (from, to) {
      this.auxModulosPre = 0
      this.auxModulosPost = 0
      if (from.id !== to.id) {
        if (from.id === 'pre') {
          this.auxModulosPre = this.moduloAgarrado.tipo === 'kyc' ? -2 : -1
        } else if (from.id === 'post') {
          this.auxModulosPost = this.moduloAgarrado.tipo === 'kyc' ? -2 : -1
        }
        if (to.id === 'pre') {
          this.auxModulosPre = this.moduloAgarrado.tipo === 'kyc' ? 2 : 1
        } else if (to.id === 'post') {
          this.auxModulosPost = this.moduloAgarrado.tipo === 'kyc' ? 2 : 1
        }
      } else {
        this.auxModulosPre = 0
        this.auxModulosPost = 0
      }
    }
  },
  watch: {
    cambiadoData (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('cambiado', newValue)
      }
    },
    validarPbcDesdeBO () {
      this.$refs.form.validate()
    },
    documentoMorosidadVisible (val) {
      if (!val) {
        this.documentoMorosidadOpcional = true
      }
    },
    documentoMorosidadOpcional (val) {
      if (!val) {
        this.documentoMorosidadVisible = true
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  @require '~vuetify/src/stylus/settings/_colors'

#base .none
  display: none

.modulo-reserva-item
  background-color: $grey["lighten-4"] !important;
  min-height: 85px
  .modulo-image
    height: 85px
    width: 100px
    max-width: 100px
  .modulo-text
    font-weight: bold
    font-size: larger

.modulo-base-item
  background-color: $grey["lighten-4"] !important;
  .modulo-image
    height: 40px
    width: 60px
    max-width: 60px
  .modulo-text
    font-size: small
    font-weight: bold

.draggable-empty
  border: 3px dashed
  border-radius: 5px
  border-color: var(--v-primary-base)
  
</style>


// WEBPACK FOOTER //
// src/components/configuracion/ConfiguracionReserva.vue